export const WA_COUNTRIES = [
  { name: "Bénin", dial: "+229" },
  { name: "Burkina Faso", dial: "+226" },
  { name: "Cap-Vert", dial: "+238" },
  { name: "Côte d'Ivoire", dial: "+225" },
  { name: "Gambie", dial: "+220" },
  { name: "Ghana", dial: "+233" },
  { name: "Guinée", dial: "+224" },
  { name: "Guinée-Bissau", dial: "+245" },
  { name: "Liberia", dial: "+231" },
  { name: "Mali", dial: "+223" },
  { name: "Mauritanie", dial: "+222" },
  { name: "Niger", dial: "+227" },
  { name: "Nigéria", dial: "+234" },
  { name: "Sénégal", dial: "+221" },
  { name: "Sierra Leone", dial: "+232" },
  { name: "Togo", dial: "+228" },
];

export const WA_COUNTRY_NAMES = WA_COUNTRIES.map((c) => c.name);

export const WA_CITIES = {
  "Bénin": ["Cotonou", "Porto-Novo", "Parakou", "Abomey-Calavi", "Ouidah"],
  "Burkina Faso": ["Ouagadougou", "Bobo-Dioulasso", "Koudougou", "Banfora"],
  "Cap-Vert": ["Praia", "Mindelo", "Santa Maria"],
  "Côte d'Ivoire": ["Abidjan", "Yamoussoukro", "Bouaké", "San-Pédro", "Grand-Bassam", "Assinie", "Korhogo", "Daloa"],
  "Gambie": ["Banjul", "Serekunda", "Brikama"],
  "Ghana": ["Accra", "Kumasi", "Tema", "Takoradi", "Cape Coast"],
  "Guinée": ["Conakry", "Kankan", "Kindia", "Labé"],
  "Guinée-Bissau": ["Bissau", "Bafatá", "Gabú"],
  "Liberia": ["Monrovia", "Gbarnga", "Buchanan"],
  "Mali": ["Bamako", "Sikasso", "Ségou", "Kayes", "Mopti"],
  "Mauritanie": ["Nouakchott", "Nouadhibou", "Rosso"],
  "Niger": ["Niamey", "Zinder", "Maradi", "Agadez"],
  "Nigéria": ["Lagos", "Abuja", "Port Harcourt", "Ibadan", "Kano"],
  "Sénégal": ["Dakar", "Thiès", "Saint-Louis", "Saly", "Mbour", "Ziguinchor", "Touba"],
  "Sierra Leone": ["Freetown", "Bo", "Kenema"],
  "Togo": ["Lomé", "Kara", "Sokodé", "Kpalimé"],
};
